<template>
	<div class="app">
		<div class="box">
			<Menu :theme="theme3" :active-name="activeName" width="12vw">
				<MenuGroup :title="CompanyTitle || '数据中心智慧综合管理平台'">
					<router-link :to="{ name: 'index' }">
						<MenuItem name="index">
						<Icon type="md-home" />
						首页
						</MenuItem>
					</router-link>
				</MenuGroup>
				<template>
					<MenuGroup title="集团" v-if="IsAdmin == '1' && IsSuperAdmin == '1'">
						<router-link :to="{ name: 'group' }">
							<MenuItem name="group">
							<Icon type="ios-people" />
							集团设置
							</MenuItem>
						</router-link>
					</MenuGroup>
					<MenuGroup title="公司" v-if="IsAdmin == '1' && IsSuperAdmin == '1'">
						<router-link :to="{ name: 'company' }">
							<MenuItem name="company">
							<Icon type="md-people" />
							公司设置
							</MenuItem>
						</router-link>
					</MenuGroup>
					<MenuGroup title="部门" v-if="IsAdmin == '1'">
						<router-link :to="{ name: 'department' }">
							<MenuItem name="department">
							<Icon type="ios-person-add" />
							部门设置
							</MenuItem>
						</router-link>
					</MenuGroup>
					<MenuGroup title="账户" v-if="IsAdmin == '1'">
						<router-link :to="{ name: 'user' }">
							<MenuItem name="user">
							<Icon type="md-person" />
							账户设置
							</MenuItem>
						</router-link>
					</MenuGroup>
				</template>
			</Menu>
			<div class="pages-rigth">
				<div class="pages-header">
					<div class="pages-header-inco">
						<img v-if="CompanyLogo" :src="CompanyLogo" alt="" />
					</div>
					<div class="pages-header-logout" @click="logout()">
						<img src="../../assets/home/logout.png" alt="" />
					</div>
				</div>
				<div class="pages-bodyer">
					<router-view />
				</div>
			</div>
		</div>
		<!-- 新增 -->
		<HomeModel :isShow="add_model" :details="details" @on-change="addChange"></HomeModel>
	</div>
</template>

<script>
	import {
		BindSystemAccount
	} from "@/api/url_api.js";
	import HomeModel from "./home_model.vue";
	import Cookies from "js-cookie";
	export default {
		components: {
			HomeModel,
		},
		data() {
			return {
				theme3: "dark",

				IsAdmin: Cookies.get("IsAdmin"),
				IsSuperAdmin: Cookies.get("IsSuperAdmin"),
				CompanyTitle: Cookies.get('CompanyTitle'),
				CompanyLogo: Cookies.get('CompanyLogo'),

				add_model: false,
				details: {},

				activeName: '',
			};
		},

		computed: {},

		mounted() {
			this.activeName = this.$route.name;
		},

		methods: {
			bind() {
				this.add_model = true;
			},
			logout() {
				let _this = this;
				Cookies.set('Token', '');
				_this.$router.push({
					name: "login",
				});
			},
			addChange(stateMsg, value) {
				let _this = this;
				_this.add_model = stateMsg;

				if (value) {
					BindSystemAccount(value)
						.then((res) => {
							if (res.Success) {
								_this.$Message["success"]({
									background: true,
									content: res.Message,
								});
								_this.$store.dispatch("setRefreshState", true);
							} else {
								_this.$Message["error"]({
									background: true,
									content: res.Message,
								});
							}
						})
						.catch((err) => {
							_this.$Message["error"]({
								background: true,
								content: err.response.Message,
							});
						});
				}
			},
		},
	};
</script>

<style scoped>
	.box>>>.ivu-menu {
		height: 100vh;
	}
	
	.box>>>.ivu-menu-dark {
		background-color: rgba(81, 90, 110, 0.2);
	}
	
	.box>>>.ivu-menu-item-group-title {
		height: 2.4vw;
		line-height: 2.4vw;
		font-size: 0.7vw;
		padding-left: 1.4vw;
	}
	.box >>> .ivu-menu-item {
		padding: 0.7vw 1.2vw;
		font-size: 0.7vw;
	}
</style>
<style src="./home.css" scoped="scoped"></style>
